import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "popup"
}
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = { class: "mentor-grid" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "mentor-name" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "button-container" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]

import { useMentorStore } from "@/store/mentorStore";
import { ref, computed, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  ...{
    name: "MentorSelection"
},
  __name: 'MentorSelection',
  setup(__props) {

const mentorStore = useMentorStore();
const currentMentorIndex = ref(0);
const isChangingMentor = ref(false);

const currentMentor = computed(() => {
    return mentorStore.mentors[currentMentorIndex.value];
});

const changeMentor = (direction: number) => {
    if (isChangingMentor.value) return;
    isChangingMentor.value = true;

    // Update the mentor index safely
    const totalMentors = mentorStore.mentors.length;
    currentMentorIndex.value = (currentMentorIndex.value + direction + totalMentors) % totalMentors;
};

// Watch for mentor change and reset the flag after transition
watch(currentMentor, () => {
    setTimeout(() => {
        isChangingMentor.value = false;
    }, 300); // Match this duration with your CSS transition
});

// Component name is now defined using <script> with defineOptions if needed


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_unref(mentorStore).isVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[4] || (_cache[4] = _createElementVNode("h1", null, "Choose Your Tutor", -1)),
              _createElementVNode("button", {
                class: "close-button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(mentorStore).hide && _unref(mentorStore).hide(...args)))
              }, "✖"),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_Transition, {
                  name: "mentor-fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (currentMentor.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: currentMentor.value.name,
                          class: _normalizeClass(["mentor-item", { selected: _unref(mentorStore).selectedMentorId === currentMentor.value.name }])
                        }, [
                          _createElementVNode("img", {
                            src: currentMentor.value.imageUrl,
                            alt: currentMentor.value.name,
                            class: "mentor-image"
                          }, null, 8, _hoisted_4),
                          _createElementVNode("div", _hoisted_5, _toDisplayString(currentMentor.value.name), 1),
                          _createElementVNode("div", {
                            class: "mentor-personality",
                            innerHTML: currentMentor.value.personality
                          }, null, 8, _hoisted_6)
                        ], 2))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "mentor-menu-button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (changeMentor(-1))),
                  disabled: isChangingMentor.value
                }, " < ", 8, _hoisted_8),
                _createElementVNode("button", {
                  class: "mentor-menu-button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(mentorStore).confirmSelection(currentMentor.value.name)))
                }, " Confirm "),
                _createElementVNode("button", {
                  class: "mentor-menu-button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (changeMentor(1))),
                  disabled: isChangingMentor.value
                }, " > ", 8, _hoisted_9)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})